export const conceptDescriptionPics = (): {
    id: number;
    desktopSrc?: string;
    mobileSrc?: string;
}[] => {
    return [
        {
            id: 1,
            desktopSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc1%401x.jpg',
            mobileSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc1%401x.jpg',
        },
        {
            id: 2,
            desktopSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc2%401x.jpg',
            mobileSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc2%401x.jpg',
        },
        {
            id: 3,
            desktopSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc3%401x.jpg',
            mobileSrc:
                'https://femme-general.s3.eu-north-1.amazonaws.com/aboutUs/definingFeatures/conceptDesc3%401x.jpg',
        },
    ];
};
